<template>
  <modal wrapperClasses="sponsor-request-modal"
    showClose
    :showActionButton="false"
    @close="closeRequestModal()">
    <h2 slot="title" class="modal-title text-3xl text-center sm:4xl sm:mt-10">
      sponsor request form
    </h2>
    <div class="my-10 sponsor-request-body" slot="body">
      <label class="flex text-left">request type:</label>
      <div class="checkboxes-wrapper flex justify-between mt-4 whitespace-nowrap ">
        <div class="sponsorship-type-checkbox flex ml-2" v-for="sponsorshipType in sponsorshipTypes" :key="sponsorshipType.id">
          <checkbox
            class="sponsorship-checkbox mr-2"
            :checked.sync="sponsorshipType.selected"
          />
          <label>{{ sponsorshipType.name }} </label>
        </div>
      </div>
      <div class="sponsorship-date-range flex flex-row items-center my-6">
        <label>date range:</label>
        <div>
          <span v-if="hasDateRange" class="date-range ml-2 rounded-lg p-2 text-white">{{ dateRange }}</span>
          <span v-else class="ml-2 text-gray-700">no preference</span>
        </div>
      </div>
      <div class="sponsorship-recipient-count whitespace-nowrap my-6 flex items-center" slot="body">
        <label for="suggested_recipient_count">suggested recipient count:</label>
        <span class="rounded-lg blue-500 m-0 ml-2 truncate p-2 text-left">{{ suggestedRecipientCount }}</span>
      </div>
      <div v-if="hasImage" class="flex whitespace-nowrap items-baseline my-6">
        <label class="mr-2"> upload a logo: </label>
        <div>
          <span class="font-primary font-bold text-gray-400 cursor-pointer">
            {{ fileName }}
          </span>
            <fai
              :icon="['fa', 'arrow-down-to-line']"
              class="fileDownload text-gray-400 cursor-pointer ml-4"
              @click="downloadFile"
            />
        </div>
      </div>
      <div class="sponsorship-notes mt-3" slot="body">
        <label class="flex text-left"> general notes: </label>
        <textarea
          rows="6"
          disabled
          class="mt-4 resize-none w-11/12 rounded-lg"
          type="text"
          v-model="generalNotes"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../Shared/Modal.vue";
import { Checkbox } from '@springbig/sb-components'
import { format } from "date-fns"

export default {
  props: {
    selectedRequest: Object
  },

  name: "AdSponsorRequestModal",

  components: {
    Modal,
    Checkbox,
  },


  data(){
    return {
      showRequestModal: true,
      sponsorTypes: [{
        name: "existing offer",
        selected: false
      }, {
        name: "new offer",
        selected: false
      }, {
        name: "product release",
        selected: false
      }, {
        name: "vendor day",
        selected: false
      }, {
        name: "other",
        selected: false
      }]
    }
  },

  computed: {
    generalNotes() {
      return this.selectedRequest?.request_log?.general_notes || ''
    },
    suggestedRecipientCount() {
      return this.selectedRequest?.request_log?.suggested_recipient_count || 0
    },
    dateRange() {
      if (!this.hasDateRange) return

      return `${format(new Date(this.selectedRequest?.request_log?.start_date), 'MM-dd-yy')} - ${format(new Date(this.selectedRequest?.request_log?.end_date), 'MM-dd-yy')}`
    },
    hasDateRange() {
      return !!this.selectedRequest?.request_log?.start_date && !!this.selectedRequest?.request_log?.end_date
    },
    hasImage(){
      return !!this.selectedRequest?.image.filename 
    },
    fileName() {
      const fileObj = this.selectedRequest.image.filename
      return fileObj || ''
    },
    sponsorshipTypes() {
      if (this.selectedRequest?.sponsor_types) {
        return this.sponsorTypes.map(type => ({...type, selected: this.selectedRequest.sponsor_types.includes(type.name)}))
      } else {
        return this.sponsorTypes
      }
    },
  },

  methods: {
    closeRequestModal(){
      this.$emit("closeModal")
    },
    async downloadFile(){
      const image_url = this.selectedRequest?.image.url
      try {
        const response = await fetch(image_url)
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", this.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch(err) {
        console.log({ err })
      }
    }
  },
}
</script>